import * as React from "react";
import { Icon } from "office-ui-fabric-react";

const ShowAllFieldsToggle = ({ showAllFields, onChange }: { showAllFields: boolean, onChange: (value: boolean) => void }) => {
    return <span className='fields-toggle' onClick={() => onChange(!showAllFields)}>
        <Icon iconName={showAllFields ? 'StockUp' : 'StockDown'} />{showAllFields ? 'Less' : 'More'} fields
    </span>
}

export default ShowAllFieldsToggle;